export default __webpack_public_path__ + "static/media/leftarrow.daf2ad7a.svg";